import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const theme = {
  primary: '#83C45D',
  secondary: '#5d3791',
  accent: '#e91e63',
  info: '#00CAE3',
  success: '#4CAF50',
  warning: '#FB8C00',
  error: '#FF5252',
  background: '#EEEEEE',
  darker: '#3c3c3b',
}

export default new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },
  theme: {
    themes: {
      light: theme
    }
  }
});
